export default __webpack_public_path__ + "static/media/standard_11.0acda7a6.png";